@if (initialLoading()) {
  <div class="flex items-center justify-center py-12">
    <div
      data-testid="account-form-wrapper-loading"
      class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"
    ></div>
  </div>
} @else {
  <app-add-form
    data-testid="account-form-wrapper-add-form"
    #addForm
    [title]="config.title"
    [formFields]="formFields()"
    [initialData]="formData()"
    (formAction)="onFormAction($event)"
    (formValueChanges)="onFormValueChanges($event)"
    (sectionAction)="onSectionAction($event)"
    [headerActions]="config.headerActions"
    [sectionButtons]="sectionButtons()"
    [editMode]="editMode"
    [viewMode]="viewMode"
    [loading]="loading()"
  ></app-add-form>
}

<p-dialog
  data-testid="account-form-wrapper-template-preview-dialog"
  [header]="'e_invoice.account.form.actions.view_template' | translate"
  [(visible)]="pdfDialogVisible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  styleClass="template-preview-dialog"
  [style]="{ width: '80vw', height: '90vh' }"
  [contentStyle]="{ overflow: 'hidden', padding: 0, height: '100%' }"
  (onHide)="closePdfDialog()"
>
  @if (pdfLoading()) {
    <div
      class="flex items-center justify-center"
      style="height: calc(90vh - 60px)"
    >
      <div
        data-testid="account-form-wrapper-pdf-loading"
        class="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600"
      ></div>
    </div>
  } @else if (pdfUrl()) {
    <iframe
      data-testid="account-form-wrapper-pdf-frame"
      [src]="pdfUrl()!"
      class="w-full border-0"
      style="height: calc(90vh - 60px)"
    ></iframe>
  }
</p-dialog>

<p-toast data-testid="account-form-wrapper-toast"></p-toast>
